// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","492":"a999d93e","624":"9380e502"}[chunkId] + ".chunk.js";
};